import React from 'react';

type Props = {
  title: string
};

class ToolbarTitle extends React.PureComponent<Props> {
  override render (): React.ReactNode {
    const { title } = this.props;

    return (
      <div className='esko_title'>
        <h1 className='esko_visible-lg-inline esko_visible-md-inline esko_visible-sm-inline'>
          {title}
        </h1>
        <h1 className='esko_visible-xs-inline' style={{visibility: 'hidden', whiteSpace: 'nowrap'}}>{title}</h1>
      </div>
    );
  }
}

export default ToolbarTitle;
